// import {
//   formatDate
// } from '@/components/BaseUi/Form/utils';

const dayList = /^(0[1-9]|[1-2]\d|3[0-1])$/;
const list = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'];
// eslint-disable-next-line prefer-destructuring
// const currentYear = formatDate(new Date()).split(' ')[0].split('-')[0];

// 校验日
export const checkBirthdayDays = function (value) {
  if (value.length > 1 && !dayList.test(value.slice(0, 2))) {
    return true;
  }
  return false;
};

// 校验月份
export const checkBirthdayMonth = function (value) {
  if (value.length > 3 && list.indexOf(value.slice(3, 5)) === -1) {
    return true;
  }
  return false;
};

// 校验年份
export const checkBirthdayYear = function (value) {
  if (value.length > 9) {
    const year = value.slice(6);
    const month = value.slice(3, 5);
    const date = value.slice(0, 2);

    const userDate = new Date();
    userDate.setFullYear(year, month - 1, date);
    const nowDate = new Date();
    // 用户必须小于这个年分出生
    nowDate.setFullYear(nowDate.getFullYear() - 18);

    if (nowDate - userDate < 0) {
      return true;
    }
    return false;
  }
};
